import _regeneratorRuntime from "babel-runtime/regenerator";
import _extends from "babel-runtime/helpers/extends";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import React, { Fragment } from "react";
import { compose, lifecycle, withProps, withState, withStateHandlers, withHandlers, pure, branch, renderComponent } from "recompose";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import ReactGA from "react-ga";

import quizzService from "../../stores/quizz";
import appService from "../../stores/app";
import { withFirebaseApp } from "../../util/firebase";
import registrationService from "../../stores/registration";
import FormSelect from "../../components/FormSelect";
import { Form, FormProperty, FormCheckbox, SubmitButton, ErrorText, Text } from "./style";

export default compose(
// Get the store data and actions
connect(function (_ref) {
  var registration = _ref.registration,
      quizz = _ref.quizz,
      _ref$app$questions = _ref.app.questions,
      questions = _ref$app$questions === undefined ? [] : _ref$app$questions;
  return {
    form: registration,
    hasWon: quizzService.hasWon(quizz, questions) // || true
  };
}, function (dispatch) {
  return {
    setFieldValue: function setFieldValue(field, value) {
      return dispatch(registrationService.setFieldValue({ field: field, value: value }));
    },
    catchError: function catchError(error) {
      return dispatch(appService.setError(error));
    }
  };
}),
// Immediately redirect if not won
branch(function (_ref2) {
  var hasWon = _ref2.hasWon;
  return !hasWon;
}, renderComponent(function (_ref3) {
  var ErrorPanel = _ref3.errorPanel;
  return ErrorPanel && React.createElement(ErrorPanel, null);
})),
// Add Firebase support
withFirebaseApp(),
// Find stores in Firebase
withState("stores", "setStores", null), lifecycle({
  componentDidMount: function componentDidMount() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _props, firebaseApp, setStores, catchError, storesSnapshot, stores;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = _this.props, firebaseApp = _props.firebaseApp, setStores = _props.setStores, catchError = _props.catchError;

              if (firebaseApp) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return firebaseApp.firestore().collection("stores").orderBy("name").get();

            case 6:
              storesSnapshot = _context.sent;
              stores = [];

              storesSnapshot.forEach(function (store) {
                stores.push(_extends({
                  id: store.id
                }, store.data()));
              });
              setStores(stores);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);

              catchError(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 12]]);
    }))();
  }
}), pure,
// Initialize the type value according to the URL
lifecycle({
  componentDidMount: function componentDidMount() {
    var _props2 = this.props,
        setFieldValue = _props2.setFieldValue,
        type = _props2.match.params.type;

    setFieldValue("type", type);
  }
}),
// Evaluates validity
withProps(function (_ref4) {
  var form = _ref4.form;
  return {
    isValid: registrationService.isValid(form),
    isIndividual: registrationService.isIndividual(form)
  };
}),
// Provides a state for sent forms
withStateHandlers({ loading: false, sent: false, error: null }, {
  isSending: function isSending() {
    return function () {
      return { loading: true, sent: false, error: null };
    };
  },
  sendComplete: function sendComplete() {
    return function () {
      return { loading: false, sent: true, error: null };
    };
  },
  catchError: function catchError() {
    return function (err) {
      return {
        loading: false,
        sent: false,
        error: err.message
      };
    };
  }
}),
// Display the success panel
branch(function (_ref5) {
  var sent = _ref5.sent;
  return !!sent;
}, renderComponent(function (_ref6) {
  var form = _ref6.form,
      SuccessPanel = _ref6.successPanel;
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Helmet,
      null,
      React.createElement("body", { className: "registration-" + form.type }),
      "}"
    ),
    !!SuccessPanel && React.createElement(SuccessPanel, { form: form })
  );
})),
// Add the function to register
withHandlers({
  register: function register(_ref7) {
    var isValid = _ref7.isValid,
        form = _ref7.form,
        firebaseApp = _ref7.firebaseApp,
        isSending = _ref7.isSending,
        sendComplete = _ref7.sendComplete,
        catchError = _ref7.catchError;
    return function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.preventDefault();

                if (firebaseApp) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                if (isValid) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", catchError({ message: "Le formulaire n'est pas valide !" }));

              case 5:
                isSending && isSending();
                _context2.prev = 6;
                _context2.next = 9;
                return firebaseApp.firestore().collection("registrations").add({
                  date: new Date(),
                  form: form,
                  visitor: typeof window !== "undefined" ? {
                    pathname: window.location.pathname,
                    referrer: window.document.referrer,

                    browser: {
                      name: window.navigator.appName,
                      product: window.navigator.product,
                      version: window.navigator.appVersion,
                      userAgent: window.navigator.userAgent,
                      language: window.navigator.language,
                      platform: window.navigator.platform
                    },

                    screen: {
                      width: window.screen.width,
                      height: window.screen.height
                    }
                  } : null
                });

              case 9:
                sendComplete();
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](6);

                catchError(_context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 12]]);
      }));

      return function (_x) {
        return _ref8.apply(this, arguments);
      };
    }();
  }
}),
// Provides a focus state for inputs
withState("focus", "setFocusOnField", null))(function Registration(_ref9) {
  var stores = _ref9.stores,
      form = _ref9.form,
      setFieldValue = _ref9.setFieldValue,
      isValid = _ref9.isValid,
      isIndividual = _ref9.isIndividual,
      focus = _ref9.focus,
      setFocusOnField = _ref9.setFocusOnField,
      register = _ref9.register,
      loading = _ref9.loading,
      sent = _ref9.sent,
      error = _ref9.error,
      labelFormStore = _ref9.labelFormStore,
      Heading = _ref9.heading;

  if (sent) {
    ReactGA.pageview(window.location.pathname + "/sent");
  } else if (error) {
    ReactGA.pageview(window.location.pathname + "/error");
  }

  var getFormPropertyProps = function getFormPropertyProps(fieldName) {
    return {
      hasFocus: focus === fieldName,
      hasValue: !!form[fieldName]
    };
  };
  var getFieldProps = function getFieldProps(fieldName) {
    return {
      name: fieldName,
      value: form[fieldName],
      onChange: function onChange(event) {
        return setFieldValue(fieldName, event.target.value);
      },
      onFocus: function onFocus() {
        return setFocusOnField(fieldName);
      },
      onBlur: function onBlur() {
        return setFocusOnField(null);
      }
    };
  };

  var storeFieldProps = getFieldProps("store");

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Helmet,
      null,
      React.createElement("body", { className: "registration-" + form.type }),
      "}"
    ),
    !!Heading && React.createElement(Heading, { isIndividual: isIndividual }),
    React.createElement(
      Form,
      { loading: loading, onSubmit: register },
      !isIndividual && React.createElement(
        FormProperty,
        _extends({
          label: "Soci\xE9t\xE9"
        }, getFormPropertyProps("company"), {
          required: true
        }),
        React.createElement("input", _extends({ type: "text" }, getFieldProps("company"), { required: true }))
      ),
      React.createElement(
        FormProperty,
        _extends({ label: "Pr\xE9nom" }, getFormPropertyProps("firstname")),
        React.createElement("input", _extends({ type: "text" }, getFieldProps("firstname")))
      ),
      React.createElement(
        FormProperty,
        _extends({ label: "Nom" }, getFormPropertyProps("lastname")),
        React.createElement("input", _extends({ type: "text" }, getFieldProps("lastname")))
      ),
      React.createElement(
        FormProperty,
        _extends({
          label: "N\xB0 de t\xE9l\xE9phone"
        }, getFormPropertyProps("phone")),
        React.createElement("input", _extends({ type: "phone" }, getFieldProps("phone")))
      ),
      React.createElement(
        FormProperty,
        _extends({ label: "Email" }, getFormPropertyProps("email"), { required: true }),
        React.createElement("input", _extends({ type: "email" }, getFieldProps("email"), { required: true }))
      ),
      React.createElement(
        FormProperty,
        _extends({
          label: labelFormStore
        }, getFormPropertyProps("store"), {
          required: true,
          hasValue: true
        }),
        React.createElement(
          FormSelect,
          _extends({}, storeFieldProps, { required: true }),
          React.createElement(
            "option",
            { value: "" },
            stores === null ? "Chargement des magasins..." : "Aucun magasin"
          ),
          stores && stores.map(function (_ref10) {
            var id = _ref10.id,
                name = _ref10.name;
            return React.createElement(
              "option",
              { key: id, value: name },
              name
            );
          })
        )
      ),
      React.createElement(
        FormCheckbox,
        {
          label: React.createElement(
            "span",
            null,
            "J'ai pris connaissance du r\xE8glement et accepte les conditions du jeu"
          )
        },
        React.createElement("input", {
          type: "checkbox",
          checked: form.accepted,
          onChange: function onChange(event) {
            return setFieldValue("accepted", !!event.target.checked);
          }
        })
      ),
      !!error && React.createElement(
        ErrorText,
        null,
        error
      ),
      React.createElement(
        SubmitButton,
        { disabled: !isValid },
        loading ? 'Envoi en cours...' : 'Envoyer'
      ),
      React.createElement(
        Text,
        null,
        "* champs obligatoires"
      )
    )
  );
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Registration/index.js
// module id = 176
// module chunks = 0